import { Snowflake } from '@orgus/ui/icons';
import type { SettingsSection } from '../registry.ts';
import { LandingView } from '../../policy/LandingView.tsx';

const section: SettingsSection = {
  id: 'landing',
  title: 'Landing and freezes',
  description: 'Checks before an item lands, and freeze windows.',
  order: 10,
  group: 'delivery',
  keywords: ['freeze', 'freezes', 'gates', 'checks', 'deploy windows'],
  icon: Snowflake,
  Component: LandingView,
};
export default section;
